import { render, staticRenderFns } from "./FaqOverview.vue?vue&type=template&id=139cfa62&scoped=true&"
import script from "./FaqOverview.vue?vue&type=script&lang=js&"
export * from "./FaqOverview.vue?vue&type=script&lang=js&"
import style0 from "./FaqOverview.vue?vue&type=style&index=0&id=139cfa62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139cfa62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VFlex,VLayout})
